import {DefaultValue, selectorFamily} from "recoil";
import {getDocuments} from "../../utils/Api";
import { documentListAtom} from "../atoms/documentAtoms";

/*
 * This selector gets documents as a list from the API given
 * report_id param and returns the list to the documentListAtom
 */
export const documentListSelector = selectorFamily({
    key: "documentListSelector",
    get: report_id => async ({get}) => {
        return await getDocuments(report_id);
    },
    set: ({set}, newValue) => {
        set(
            documentListAtom,
            newValue instanceof DefaultValue && newValue
        )

    }
})